import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import { styled } from '@material-ui/styles'
import { FC, useRef, useState } from 'react'
import Dialog from '../../../../control/dialog/dialog'
import useTranslate from '../../../../i18n/useTranslate'
import { GetProjectCertificateResponse, ItemListType } from '../../../../services/web/types/responseWebServiceTypes'
import useCeritificates from '../../../../services/web/useCertificates'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'

const CustomLabel = styled((props: TypographyProps & { hasCoaNo: boolean }) => <Typography {...props} />)(
    ({ hasCoaNo }) => ({
        color: hasCoaNo ? '#0062FF' : '#000000',
        textDecoration: hasCoaNo ? 'underline' : 'none',
        cursor: hasCoaNo ? 'pointer' : 'default',
    }),
)

const CustomButton = styled(Button)({
    border: '1px solid #DB5F8E',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
})

const DialogCoaButton: FC<{
    projectInfo: ItemListType
}> = ({ projectInfo }) => {
    const { coaNo, projectID } = projectInfo
    const translate = useTranslate()
    const { getCertificatesByProjectId } = useCeritificates()
    const dialogRef = useRef<Record<string, Function>>()
    const [certificates, setCertificates] = useState<GetProjectCertificateResponse[]>([])

    const bindingDialogRef = (func: Record<string, Function>) => {
        dialogRef.current = { ...func }
    }

    const handleCloseDialog = () => {
        dialogRef?.current?.closeDialog()
    }

    const handleOpenCoa = async () => {
        if (coaNo && dialogRef?.current) {
            const response = await getCertificatesByProjectId(projectID)
            if (response?.result) {
                const result = response?.result
                setCertificates(result)
            }
            dialogRef?.current?.openDialog()
        }
    }

    return (
        <>
            <CustomLabel noWrap variant={'body2'} onClick={handleOpenCoa} hasCoaNo={coaNo ? true : false}>
                {coaNo ?? '-'}
            </CustomLabel>
            <Dialog
                maxWidth="xs"
                onRef={bindingDialogRef}
                type=""
                title={translate.get('LABEL.CERTIFICATE_INFORMATION')}
                content={
                    <>
                        <Grid container justify="center" spacing={1}>
                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={7}>
                                        <Typography variant="caption" color="textSecondary">
                                            {translate.get('LABEL.COA_NO')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="textSecondary">
                                            {translate.get('LABEL.CERTIFICATE_RECEIVE_DATE')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {certificates.map((certData) => (
                                <Grid item xs={12} key={certData.certificate_id}>
                                    <Grid container>
                                        <Grid item xs={7}>
                                            <CustomLabel hasCoaNo={coaNo ? true : false} style={{ cursor: 'default', color: 'black', textDecoration: 'unset' }}>
                                                {certData.coa_no}
                                            </CustomLabel>
                                        </Grid>
                                        <Grid item xs={4}>
                                            {translate.languageStore.currentLanguage === translate.languageKey.th
                                                ? certData.received_date &&
                                                  convertDateToFormatTH(certData.received_date)
                                                : certData.received_date &&
                                                  convertDateToFormatEN(certData.received_date)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                            <Grid item xs="auto">
                                <pre />
                                <CustomButton onClick={handleCloseDialog}>
                                    {translate.get('BUTTON.CLOSE_MODAL')}
                                </CustomButton>
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}

export default DialogCoaButton
